import React, { useEffect, useState } from "react";
import {
  ShieldCheck,
  FileText,
  Store,
  ShoppingBag,
  CreditCard,
  Truck,
  Bell,
  MapPin,
  UserCheck,
  Ban,
  AlertTriangle,
  UserX,
  RefreshCw,
} from "lucide-react";
import {useConfig} from "../../components/Context/ConfigContext";

const TermsAndConditions = () => {
    const {configData} = useConfig();

    const fullTerms = [
    {
      id: 1,
      icon: <FileText size={18} />,
      title: "Definitions",
      content: `Platform refers to Dukansetu application.
User refers to customers and store owners.
Store Owner refers to registered businesses managing stores.
Customer refers to users placing orders.`,
    },
    {
      id: 2,
      icon: <UserCheck size={18} />,
      title: "User Registration",
      content: `Users must provide accurate information during registration.
Store owners are responsible for managing their store data, products, and pricing.`,
    },
    {
      id: 3,
      icon: <Store size={18} />,
      title: "Store Management",
      content: `Store owners can create and manage multiple stores.
Each store can have its own categories and products.
Store owners are responsible for accuracy of product details, pricing, and availability.`,
    },
    {
      id: 4,
      icon: <ShoppingBag size={18} />,
      title: "Order Process",
      content: `Customers can place orders from nearby stores.
Orders can be placed without upfront payment.`,
    },
    {
      id: 5,
      icon: <CreditCard size={18} />,
      title: "Payment Terms",
      content: `Payments are handled directly between customer and store.
Customers may pay via:
• Cash
• Online (if accepted by store)
Store owner must update payment status (paid/unpaid).`,
    },
    {
      id: 6,
      icon: <Truck size={18} />,
      title: "Delivery & Pickup",
      content: `Orders can be fulfilled via:
• Pickup by customer
• Delivery by store
Dukansetu is not responsible for delivery delays or issues.`,
    },
    {
      id: 7,
      icon: <Bell size={18} />,
      title: "Notifications",
      content: `Customers and store owners will receive notifications for:
• Order placement
• Order status updates
• Payment updates`,
    },
    {
      id: 8,
      icon: <MapPin size={18} />,
      title: "Location Services",
      content: `Dukansetu uses user location (latitude/longitude) to show nearby stores.
Users may pin their address using map features.`,
    },
    {
      id: 9,
      icon: <ShieldCheck size={18} />,
      title: "User Responsibilities",
      content: `Customers must provide correct order details.
Store owners must fulfill accepted orders responsibly.`,
    },
    {
      id: 10,
      icon: <Ban size={18} />,
      title: "Prohibited Activities",
      content: `Users must not:
• Provide false information
• Misuse the platform
• Engage in fraudulent activities`,
    },
    {
      id: 11,
      icon: <AlertTriangle size={18} />,
      title: "Limitation of Liability",
      content: `Dukansetu is a facilitator platform and is not responsible for:
• Product quality
• Payment disputes
• Delivery issues`,
    },
    {
      id: 12,
      icon: <UserX size={18} />,
      title: "Termination",
      content: `We reserve the right to suspend or terminate accounts for misuse or violation of terms.`,
    },
    {
      id: 13,
      icon: <RefreshCw size={18} />,
      title: "Changes to Terms",
      content: `We may update these terms at any time. Continued use of the platform implies acceptance.`,
    },
    {
      id: 14,
      icon: <ShieldCheck size={18} />,
      title: "Product Authenticity & Pricing Policy",
      content: `Store Owners must ensure that all products listed are:
• Genuine
• Legal
• Not counterfeit or duplicate

Store Owners are responsible for:
• Accuracy of product details
• Correct pricing
• Product quality

Strictly prohibited:
• Fake products
• Incorrect pricing
• False descriptions

Dukansetu is NOT responsible for:
• Product authenticity
• Quality issues
• Pricing discrepancies

In case of violations:
• Products may be removed
• Accounts may be suspended

Customers should verify products before payment.`,
    },
  ];

  return (
    <div className="min-h-screen bg-zinc-50 dark:bg-slate-950 font-sans">
      {/* HEADER */}
      <div className="sticky top-0 z-50 bg-white/80 dark:bg-slate-950/80 backdrop-blur border-b border-zinc-200 dark:border-slate-800">
        <div className="max-w-5xl mx-auto px-6 py-6 text-center">
          <h1 className="text-3xl font-black text-zinc-900 dark:text-white">
            📜 Terms & Conditions
          </h1>
          <p className="text-sm text-zinc-500 dark:text-slate-400 mt-2">
            Please read carefully before using DukaanSetu
          </p>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-5xl mx-auto px-6 py-10 space-y-6">
        {fullTerms.map((item) => (
          <div
            key={item.id}
            className="bg-white dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm hover:shadow-md transition"
          >
            <div className="flex items-start gap-4">
              {/* ICON */}
              <div className="p-3 rounded-xl bg-orange-500 text-white">
                {item.icon}
              </div>

              {/* TEXT */}
              <div>
                <h3 className="font-black text-lg text-zinc-900 dark:text-white mb-2">
                  {item.id}. {item.title}
                </h3>

                <p className="text-sm text-zinc-600 dark:text-slate-300 whitespace-pre-line leading-relaxed">
                  {item.content}
                </p>
              </div>
            </div>
          </div>
        ))}
        <div className="mt-10 text-center">
          <p className="text-sm text-zinc-500 dark:text-slate-400">
            For any queries, contact us at{" "}
            <a
              href={`mailto:${configData?.support_email}`}
              className="text-orange-500 font-semibold hover:underline"
            >
                {configData?.support_email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
